import { LogoutIcon, SuccessIcon } from 'components/icons'
import Layout from 'components/layout/layout'
import PageLayout from 'components/layout/paywall/page-layout'
import UpgradeForm from 'components/layout/paywall/upgrade-form'
import { Tooltip } from 'components/ui'
import { useApp } from 'context/app-context'
import { useCurrentUser } from 'context/current-user-context'
import classNames from 'helpers/class-names'
import useSubscriptionListener from 'hooks/use-subscription-listener'
import Head from 'next/head'
import { useRouter } from 'next/router'

const Paywall = ({ children }) => {
  const router = useRouter()
  const { env } = useApp()
  const { isExpired, isAdmin, logout } = useCurrentUser()
  const isPublic = router.pathname.startsWith('/parts/public')
  useSubscriptionListener()

  const modal = (
    <div className="relative mx-auto flex flex-col items-end overflow-hidden rounded-3xl bg-info shadow-xl md:flex-row xl:max-w-5xl">
      <button
        className="absolute right-4 top-4 text-white/40 transition-all duration-300 hover:text-white"
        onClick={logout}>
        <Tooltip tip="Log out" placement="left">
          <LogoutIcon className="size-5" />
        </Tooltip>
      </button>

      <div className="w-full flex-1 p-12 md:w-1/2 lg:pr-16">
        <h1 className="font-display text-4xl font-bold text-white">
          Your Trial Has Expired
        </h1>
        <p className="pt-6 leading-relaxed text-white">
          Upgrade now to discover how Toolpath is transforming the way machine
          shops approach CNC machining.
        </p>
        <div className="flex flex-col gap-2 py-6">
          <div className="flex flex-row items-center gap-2 text-white">
            <SuccessIcon className="size-5 text-gray-700/60" />
            <div>Effortlessly Generate Quotes</div>
          </div>
          <div className="flex flex-row items-center gap-2 text-white">
            <SuccessIcon className="size-5 text-gray-700/60" />
            <div>Fusion CAM Integration</div>
          </div>
          <div className="flex flex-row items-center gap-2 text-white">
            <SuccessIcon className="size-5 text-gray-700/60" />
            <div>Simplify Your Workflow</div>
          </div>
        </div>
        {isAdmin && <UpgradeForm />}
      </div>
      <div className="flex-1 pl-12 md:w-1/2 md:pl-0">
        <div className="lg:h-68 h-auto flex-1 overflow-hidden rounded-tl-lg">
          <img
            src={`${env.CDN_URL}/images/screenshots/bike-clamp-report-screenshot.png`}
            alt="Screenshot of a Report page."
            className="object-cover"
          />
        </div>
      </div>
    </div>
  )

  if (!isExpired || isPublic) {
    return children
  }

  return (
    <Layout>
      <Head>
        <title>Trial Expired - Toolpath</title>
      </Head>
      <PageLayout />
      <div
        onClick={(e) => {
          e.stopPropagation()
        }}
        className={classNames(
          'fixed left-0 top-0 h-full w-full bg-gray-900 text-center',
          'hide-scrollbar overflow-scroll transition duration-200 ease-in-out',
          'mt-14 bg-opacity-70 backdrop-blur dark:bg-opacity-90 md:mt-0',
        )}
      />
      <div
        className={classNames(
          'fixed inset-x-0 top-0 mx-auto p-4 sm:w-5/6 sm:items-center sm:p-0',
        )}
        onClick={(e) => e.stopPropagation()}>
        <div
          role="alertdialog"
          aria-modal="true"
          className={classNames(
            'relative mt-18 w-full overflow-hidden dark:bg-gray-500 sm:w-5/6 md:mt-10',
            'scale-100 text-left opacity-100 transition duration-100 sm:mx-auto sm:w-auto',
            'rounded-2xl bg-transparent shadow-none',
          )}>
          <div className="max-h-[calc(100vh-6rem)]">{modal}</div>
        </div>
      </div>
    </Layout>
  )
}

export default Paywall
